import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";

bootstrapUtils.addStyle(Button, "orange");

class AddCourseModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      course_name: "",
      loading: false,
      showError: false
    };
  }

  changeInput = e => {
    const input = e.target;

    this.setState({
      [input.name]: input.value
    });
  };

  submit = () => {
    const { course_name } = this.state;

    if (course_name === "") {
      this.setState({
        showError: true
      });

      return;
    }

    this.setState({
      loading: true,
      showError: false
    });
    this.props.addCourse(course_name, this.after_submit);
  };

  after_submit = () => {
    this.setState({
      loading: false,
      course_name: ""
    });
  };

  render() {
    const { show, onHide } = this.props;
    const { course_name, loading, showError } = this.state;

    return (
      <Modal
        show={show}
        dialogClassName="modal-dialog-instructor"
        onHide={onHide}
      >
        <Modal.Body>
          {showError === true && (
            <div className="alert alert-danger">
              <b>Course Name</b> is required!
            </div>
          )}
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr className="border-none instructor-modal-row">
                  <td>Course Name</td>
                  <td className="text-center">
                    <input
                      name="course_name"
                      value={course_name}
                      onChange={this.changeInput}
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr className="border-none instructor-modal-row">
                  <td />
                  <td>
                    <Button
                      bsStyle="orange"
                      onClick={this.submit}
                      block={true}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Save"}
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AddCourseModal;



// WEBPACK FOOTER //
// ./src/instructor/components/add-course-modal.js